<template>
  <el-dialog
    :title="`盘库单明细(单号：${outInfo.code})`"
    :visible.sync="visible"
    width="720px"
    append-to-body
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      label-position="top"
      label-width="90px">
      <el-form-item
        label="仓库:">
        {{ outInfo.warehouseNo | warehouseName() }}
      </el-form-item>
      <el-form-item
        label="备注信息:"
        prop="bizDesc">
        {{ outInfo.bizDesc }}
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      max-height="600px"
      border
      :data="outInfo.detailList">
      <el-table-column
        label="商品名称"
        prop="skuName"></el-table-column>
      <el-table-column
        label="商品规格"
        prop="skuSpec"></el-table-column>
      <el-table-column
        label="盘点数量"
        width="100"
        prop="checkNum">
        <template slot-scope="{row}">{{ row.checkNum }} {{ row.measureUnit | measureUnitName() }}</template>
      </el-table-column>
      <el-table-column
        label="库存数量"
        width="100"
        prop="stockNum">
        <template slot-scope="{row}">{{ row.stockNum }} {{ row.measureUnit | measureUnitName() }}</template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'DetailModal',
  components: { },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      outInfo: {},
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        checkOrderId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config = {
        pageNum: 1,
        pageSize: 10,
        checkOrderId: null
      }
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/checkorderdetail', {
        payload: {
          ... this.config,
          vendorId: this.userInfo.orgId
        },
        success: res => {
          this.loading = false
          this.outInfo = res.data.data
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config.checkOrderId = row.id
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
